import { IssueRefFragmentDoc, isType } from '@spotify/confidence-graphql';
import { createCollectionEntryExtension } from '@spotify/plugin-confidence-collections-react';

import { issuesPlugin } from '../plugin';
import { issueRouteRef } from '../routes';

export const IssueCollectionEntryExtension = issuesPlugin.provide(
  createCollectionEntryExtension({
    id: 'issue',
    resourceType: 'Issue',
    routeRef: issueRouteRef,
    fragment: IssueRefFragmentDoc,
    predicate: ({ resource }) => isType(resource, 'ObservationsV1Issue'),
    render: () => null,
  }),
);
